import { useMenuDataJson } from '../../hooks/useMenuDataJson'
import './LocationSection.css'

const PEDIX_URL = 'https://pedix.app/mister-burger/'

const LocationSection = () => {
  const { data } = useMenuDataJson()
  const locationInfo = data?.locationInfo || {
    address: '', phone: '', hours: '', whatsapp: ''
  }
  const encodedAddress = encodeURIComponent(locationInfo.address || '')
  const latitude = typeof locationInfo.lat !== 'undefined' ? parseFloat(locationInfo.lat) : NaN
  const longitude = typeof locationInfo.lng !== 'undefined' ? parseFloat(locationInfo.lng) : NaN
  const hasCoords = Number.isFinite(latitude) && Number.isFinite(longitude)
  const hasAddress = Boolean(locationInfo.address && locationInfo.address.trim().length > 0)
  const hasDestination = hasCoords || hasAddress
  const destinationParam = hasCoords ? `${latitude},${longitude}` : encodedAddress

  const handleDirectionsClick = () => {
    if (!hasDestination) return
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${destinationParam}`, '_blank', 'noopener,noreferrer')
  }

  const handleOrderClick = () => {
    window.open(PEDIX_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <section className="locations-section" id="location">
      <div className="container">
        <div className="location-section-heading">
          <div>
            <span className="location-kicker">Ubicación</span>
            <h3>Hacé tu pedido o pasá por Mister.</h3>
          </div>
          <p>
            Estamos en Mota Botello 320, San Fernando del Valle de Catamarca.
            Elegí tu burger, lomo, wrap o ensalada, y nosotros nos encargamos del resto.
          </p>
        </div>

        <div className="location-shell">
          <div className="location-panel">
            <div className="location-title">
              <span className="location-address-tag">Mota Botello 320</span>
              <h4>La noche se pide en Mister.</h4>
            </div>

            <div className="location-details">
              <div className="location-item">
                <span aria-hidden="true">01</span>
                <div>
                  <h5>Dirección</h5>
                  <p>{locationInfo.address}</p>
                </div>
              </div>

              <div className="location-item">
                <span aria-hidden="true">02</span>
                <div>
                  <h5>Horarios</h5>
                  <p>{locationInfo.hours}</p>
                </div>
              </div>

              <div className="location-item">
                <span aria-hidden="true">03</span>
                <div>
                  <h5>Pedido</h5>
                  <p>Hacemos envíos y también podés retirar por el local.</p>
                </div>
              </div>
            </div>

            <div className="location-actions">
              <button className="location-button primary" onClick={handleDirectionsClick}>
                Ver mapa
              </button>
              <button className="location-button secondary" onClick={handleOrderClick}>
                Pedir ahora
              </button>
            </div>
          </div>

          <div className="map-stage" aria-label="Mapa visual de Mister Burger">
            <button
              className="map-pin"
              type="button"
              onClick={handleDirectionsClick}
              disabled={!hasDestination}
              aria-label="Abrir ubicación de Mister Burger en Google Maps"
            >
              <img src="/images/mister-logo.png" alt="" aria-hidden="true" />
              <strong>Estamos acá</strong>
            </button>
            <p>
              Porque una buena burger merece una mejor experiencia. Hacé tu pedido.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LocationSection
